// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ce-b";
export var colorBlue = "_ce-8";
export var colorDot = "_ce-0";
export var colorDotLarge = "_ce-2";
export var colorDotSmall = "_ce-1";
export var colorGreen = "_ce-7";
export var colorGrey = "_ce-3";
export var colorOrange = "_ce-5";
export var colorPink = "_ce-a";
export var colorPurple = "_ce-9";
export var colorRed = "_ce-4";
export var colorYellow = "_ce-6";